<template>
  <div v-loading="loading">
    <el-tabs v-model="activeName">
      <el-tab-pane :label="'状态'" name="status">
        <status :deviceDid="deviceDid" :deviceSn="deviceSn" :data="status"></status>
      </el-tab-pane>
      <el-tab-pane :label="'配置'" name="config">
        <config :conn="status.conn" :deviceDid="deviceDid" @updateData="getConfig" :deviceSn="deviceSn"
          :mode="status.mode" :serial="status.serial"></config>
      </el-tab-pane>
      <el-tab-pane :label="'高级'" name="senior">
        <Senior :data="senior" :deviceDid="deviceDid" :deviceSn="deviceSn"></Senior>
      </el-tab-pane>
    </el-tabs>
    <div class="button">
      <el-button type="primary" size="mini" @click="getConfig">刷新</el-button>
    </div>
  </div>
</template>

<script>
import {
  updateConfig,
  listConfig,
} from "@/api/configurationlist";
import status from "./components/status.vue";
import Senior from "./components/senior.vue"
import config from "./components/config.vue";
export default {
  name: "Smartloc",
  props: ["deviceDid", "deviceSn"],
  components: {
    Senior,
    status,
    config,
  },
  data() {
    return {
      loading: false,
      activeName: 'status',
      config: {},
      status: {
        satelliteData: [],
        baseData: [],
        loc: {},
        conn: [],
        serial: {},
        mode: {}
      },
      senior: {}
    };
  },
  methods: {
    async getConfig() {
      this.loading = true;
      const ciot = await listConfig(this.deviceSn, this.deviceDid, [
        {
          section: 'system',
          config: 'ciot',
          options: [
            { option: 'hardware_class' }
          ]
        },
      ]);
      let hardware_class = ciot.data.data.mess[0].s_objects[0].options.hardware_class;
      let gps = [{
        config: 'smartloc',
        section: 'GPS1',
        options: [
          { option: "enabled" },
          { option: "name" },
          { option: "mode" },
          { option: "loc_mode" },
          { option: "interval" },
          { option: "realtime_forward" },
          { option: "enable_hbt" },
          { option: "gps_device" },
        ]
      }];
      if (hardware_class.indexOf('SM') == -1) {
        gps.push({
          config: 'smartloc',
          section: 'GPS2',
          options: [
            { option: "enabled" },
            { option: "name" },
            { option: "mode" },
            { option: "loc_mode" },
            { option: "interval" },
            { option: "realtime_forward" },
            { option: "enable_hbt" },
            { option: "gps_device" },
          ]
        })
      }
      const resp = await listConfig(this.deviceSn, this.deviceDid, [
        {
          section: "service",
          config: "smartloc",
          options: [
            { option: "enabled" },
            { option: "enable_debug" },
            { option: "log_file_num" },
            { option: "log_file_size" },
            { option: "log_priority" },
            { option: "tcp_keepalive_time" },
            { option: "tcp_keepalive_interval" },
            { option: "tcp_keepalive_probes" },
          ]
        },
        {
          section: "centerserver",
          config: "loc",
          options: [
            { option: "status" },
            { option: "satellites_num" },
            { option: "bd_sate_num" },
            { option: "gps_sate_num" },
            { option: "gl_sate_num" },
            { option: "other_sate_num" },
            { option: "satellites_date" },
            { option: "satellites_time" },
            { option: "latitude" },
            { option: "longitude" },
          ]
        },
        {
          section: "conn",
          config: "smartloc",
          options: [
            { option: "enabled" },
            { option: "name" },
            { option: "enable_hbt" },
            { option: "mode" },
            { option: "listen_port" },
            { option: "proto" },
            { option: "conn_num" },
            { option: "conn_status" },
            { option: "gps_device" },
            { option: "loc_dev_id" },
            { option: "username" },
            { option: "password" },
            { option: "topic_sub" },
            { option: "topic_pub" },
            { option: "mqtt_qos" },
            { option: "mqtt_cid" },
            { option: "mqtt_alive" },
            { option: "enable_hbt" },
            { option: "hbt_interval" },
            { option: "hbt_data" },
            { option: "realtime_forward" },
            { option: "interval" },
            { option: "loc_mode" },
          ],
          lists: [
            { list: "server" },
          ]
        },
        {
          section: "serial",
          config: "smartloc",
          options: [
            { option: "baudrate" },
            { option: "parity" },
            { option: "data_bits" },
            { option: "stop_bits" },
            { option: "flow_ctrl" },
            { option: "enable_frame" },
            { option: "timeout" },
            { option: "frame_len" },
          ]
        },
        {
          section: "mode",
          config: "smartloc",
          options: [
            { option: "enabled" },
            // { option: "uplink" },
            // { option: "downlink" },
          ],
          lists: [
            { list: "uplink" },
            { list: "downlink" },
          ]
        },
        ...gps,
      ]);
      this.senior = resp.data.data.mess[0].s_objects[0].options;
      this.status.loc = resp.data.data.mess[1].s_objects[0].options;
      // this.status.conn
      this.$set(this.status, "conn", resp.data.data.mess[2].s_objects);
      this.$set(this.status, "serial", resp.data.data.mess[3].s_objects);
      this.$set(this.status, "mode", resp.data.data.mess[4].s_objects);
      this.status.satelliteData = [];
      this.status.satelliteData.push(resp.data.data.mess[5].s_objects[0].options);
      if (hardware_class.indexOf('SM') == -1) {
        this.status.satelliteData.push(resp.data.data.mess[6].s_objects[0].options);
      }
      let options = [

      ]
      if (hardware_class.indexOf('SM') != -1) {
        options.push({
          config: '3gwan1',
          section: 'cellinfo',
          options: [
            { option: 'rat' },
            { option: 'mcc' },
            { option: 'mnc' },
            { option: 'arfcn' },
            { option: 'sid' },
            { option: 'lac' },
            { option: 'nid' },
            { option: 'bid' },
          ]
        })
      } else {
        options.push({
          config: '3gwan1',
          section: 'cellinfo',
          options: [
            { option: 'rat' },
            { option: 'mcc' },
            { option: 'mnc' },
            { option: 'arfcn' },
            { option: 'sid' },
            { option: 'lac' },
            { option: 'nid' },
            { option: 'bid' },
          ]
        },
          {
            config: '3gwan2',
            section: 'cellinfo',
            options: [
              { option: 'rat' },
              { option: 'mcc' },
              { option: 'mnc' },
              { option: 'arfcn' },
              { option: 'sid' },
              { option: 'lac' },
              { option: 'nid' },
              { option: 'bid' },
            ]
          })
      }
      const resp2 = await listConfig(this.deviceSn, this.deviceDid, options);
      this.status.baseData = [];
      if (hardware_class.indexOf('SM') != -1) {
        this.status.baseData.push({ ...resp2.data.data.mess[0].s_objects[0].options, name: '3gwan1' });
      } else {
        this.status.baseData.push({ ...resp2.data.data.mess[0].s_objects[0].options, name: '3gwan1' });
        this.status.baseData.push({ ...resp2.data.data.mess[1].s_objects[0].options, name: '3gwan2' });
      }
      this.loading = false;
    }
  },
  mounted() {
    this.getConfig();
  },
  // watch: {
  //   deviceSn: {
  //     async handler(newV) {
  //       this.loading = true;
  //       await this.getConfig();
  //       this.loading = false;
  //     },
  //     immediate: true,
  //   },
  // },
};
</script>
<style scoped>
.button {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 10px;
}
</style>